import { useToken } from '@ori/auth';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';
import useSWR from 'swr';

import { useConfiguration } from '../../../contexts';

const axiosClient = axios.create();

const getEncodedImage = (blob: Blob): string => URL.createObjectURL(blob);

export function useSponsorImage(registrationId: string, profileImageDocumentId?: number | null) {
  const { globalApiUrl, tenant } = useConfiguration();
  const { formattedToken } = useToken();
  const shouldFetch = Boolean(profileImageDocumentId !== null && profileImageDocumentId !== undefined);
  const url = `${globalApiUrl}/customerRegistrations/${registrationId}/sponsorDetails/profileImage`;

  const { data: sponsorImage } = useSWR(shouldFetch ? url.toString() : null, async (requestUrl: string) => {
    const headers: AxiosRequestConfig['headers'] = {
      'x-tenant-context': tenant,
    };
    headers.Authorization = formattedToken;
    const { data } = await axiosClient
      .get<Blob>(requestUrl, {
        headers,
        responseType: 'blob',
      })
      .then((blob) => blob)
      .catch((error: AxiosResponse<Blob>) => error);

    return data;
  });

  return sponsorImage === undefined ? undefined : getEncodedImage(sponsorImage);
}
